// libs
import { styled } from '@nykaa/ui-components';
import { css } from '@emotion/core';

// components
import BaseCouponRow from 'shared/ui-components/Coupon';

// defs
import { BREAKPOINTS } from 'shared/styles/base';
import { COUPON_TYPE } from 'shared/layouts/Coupons/types';

// styles
export const Container = styled.div`
  padding: ${({ theme }) => `${theme.spacing.spacing100} ${theme.spacing.spacing100}`};
`;

export const Title = styled.h2`
  margin: 0;
  ${({ theme }) => theme.typography.titleMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const SubTitle = styled.h3<{ disabled: boolean }>`
  margin-top: ${({ theme }) => theme.spacing.spacing10};
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  ${({ disabled, theme }) => disabled && `margin-bottom: ${theme.spacing.spacing80};`}
`;

export const CouponRow = styled(BaseCouponRow)`
  &:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  }
`;

export const CouponRowPDP = styled(BaseCouponRow)<{
  extraInfoPadding?: boolean;
  type: COUPON_TYPE;
}>`
  position: relative;
  padding-top: 8px;

  ${({ theme, type }) => type === COUPON_TYPE.OFFER && `margin-bottom: ${theme.spacing.spacing10}`};

  ${({ theme, type }) =>
    css`
      @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
        margin-bottom: ${theme.spacing.spacing60};
        ${type === COUPON_TYPE.OFFER && `margin-bottom: ${theme.spacing.spacing20}`};
      }
    `}

  .infoContainer {
    &.hasTimer {
      padding-top: ${({ theme }) => theme.spacing.spacing80};
    }
    ${({ theme, extraInfoPadding }) =>
      css`
        padding: ${theme.spacing.spacing80} ${theme.spacing.spacing80} ${theme.spacing.spacing60}
          ${theme.spacing.spacing80};
        padding-bottom: ${extraInfoPadding ? theme.spacing.spacing80 : ''};

        @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
          padding: ${theme.spacing.spacing80} ${theme.spacing.spacing80} ${theme.spacing.spacing80};
          ${extraInfoPadding && `padding-bottom: ${theme.spacing.spacing60}`};
        }
        background-position: top;
      `}

    .infoContent {
      margin: 0;
      max-width: 100%;
    }
  }
  .iconContainer {
    width: 56px;
    height: 56px;
    @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
      height: 40px;
    }

    ${({ theme }) => `margin-right:${theme.spacing.spacing60}`};
  }
  .couponCode {
    letter-spacing: 0.3px;
  }
  .couponTitle {
    ${({ theme }) =>
      css`
        ${theme.typography.buttonMedium};
      `};
  }
  .couponDescription {
    ${({ theme }) =>
      css`
        color: ${theme.colors.textSecondary};
      `};
  }
  .coupon-background-image {
    background: transparent;
  }
`;
